const HuntingTicketsList = () => import(/* webpackChunkName: "IndividualPersonHuntingTickets" */ 'RootDir/modules/HuntingTickets/HuntingTickets/List.vue');

const HuntingTicketsExtraditionList = () => import(/* webpackChunkName: "IndividualPersonHuntingTickets" */ 'RootDir/modules/HuntingTickets/HuntingTicketExtradition/List.vue');
const HuntingTicketsVisitSchedule = () => import(/* webpackChunkName: "IndividualPersonHuntingTickets" */ 'RootDir/modules/HuntingTickets/HuntingTicketExtradition/VisitSchedule.vue');

const HuntingTicketAnnulJournalList = () => import(/* webpackChunkName: "IndividualPersonHuntingTickets" */ 'RootDir/modules/JournalAnnulment/List.vue');

export default [
  {
    path: 'list',
    name: 'hunting-tickets-list',
    component: HuntingTicketsList,
  },
  {
    path: 'extradition-list',
    name: 'hunting-tickets-extradition-list',
    component: HuntingTicketsExtraditionList,
  },
  {
    path: 'visit-schedule',
    name: 'hunting-tickets-visit-schedule',
    component: HuntingTicketsVisitSchedule,
  },
  {
    path: 'annul-journal-list',
    name: 'hunting-tickets-annul-journal-list',
    component: HuntingTicketAnnulJournalList,
  },
];
